import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

interface NewsCardProps {
  item: NewsItem;
}

export default function NewsCard({ item }: NewsCardProps) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col sm:flex-row gap-4 p-3 rounded-lg bg-background-100 border border-background-200/70 hover:border-accent-300 transition-colors duration-300 cursor-pointer"
    >
      <div className="relative w-full sm:w-48 shrink-0 aspect-[12/7] sm:aspect-[12/7] rounded-md overflow-hidden bg-secondary-200">
        <img
          src={item.cover}
          alt={`${item.title}资讯配图`}
          title={`${item.title}相关影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 min-w-0 py-1">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-800 font-label">
            {item.category}
          </span>
          <span>{item.date}</span>
        </div>
        <h3 className="mt-2 font-heading font-semibold text-foreground-950 text-base md:text-lg leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {item.summary}
        </p>
      </div>
    </Link>
  );
}